export default function (dsf,options) {
  return {
    id: "",
    name: "",
    code: "",
    type: dsf.metadata.mmtype(3),
    at: "",
    currentControl: null,
    controls: [],
    validate: dsf.metadata.validate(),
    defaultValue: null,
    isJSONString:true,
    valueAttributes: [
      {
        name: "图片上传",
        code: "img",
        type: dsf.metadata.getDataType("object"),
        length: 500,
        defaultValue: null,
        unit: null,
        encrypt:false
      },
    ],
  };
}
